import http from 'hub-http/clients/apiClient';
export const getIntegrationsAuthenticatedFile = engagementId => {
  return http.get(`recording/auth/provider/hublets/v1/url-retriever/getRecordingUrl/engagement/${engagementId}`);
};